
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import {
  email,
  required,
  minLength
} from "vuelidate/lib/validators";
import errorParseNetwork from "~/helpers/errorParseNetwork";
import {getAdditionalData, parseUtmLabels} from "~/helpers/formSend";
import {homePageWatcher} from "~/helpers/is-main-page";

export default BaseCmsBlock.extend({
  name: "FeedbackFormBlock",

  data: function () {
    return {
      form: {
        name: "",
        phone: "",
        email: ""
      },

      isAccept: true
    }
  },

  computed: {
    errorName: function () {
      const error = this.$v?.form?.name;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }

      return null
    },
    errorPhone: function () {
      const error = this.$v?.form?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },
    errorEmail: function () {
      const error = this.$v?.form?.email;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.email) {
        return "Неправильный формат ввода"
      }

      return null
    },

    pageAliasPolicy: function () {
      return this.$nuxt?.context?.env?.pageAliasPolicy || "#"
    },

    imageId: function () {
      return this.externalData?.FeedbackFormBlock?.imageId || this.values.image
    },

    isMobile: function () {
      return this.$store.state.device?.device?.isMobile || false
    },
    isUseRecaptcha: function () {
      return Boolean(this.$store.state.appState?.config?.useReCaptchaForForms)
    },
    isHome: function () {
      return homePageWatcher(this.$route.fullPath)
    },
    feedbackFormBlockClasses: function () {
      const _classes = [];
      if (this.cfgs.theme && this.cfgs.theme.length) {
        _classes.push(this.cfgs.theme || 'light');
      }
      if (this.isHome) {
        _classes.push('padding-home');
      }
      return _classes;
    },
  },

  validations: function () {
    const form = {
      name: {
        required,
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        minLength: minLength(18)
      },
    };

    return {
      form,
    };
  },

  methods: {
    submitForm: async function (codeRecaptcha = '') {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      const body = {
        type: "Остались вопросы, свяжитесь с нами",
        name: this.form.name,
        phone: (this.form?.phone || "").replace(/[^\d]/g, ''),
        email: this.form?.email || "",
        url: window.location.href,
        source: this.$cookies.get('sbjs_current') || '',
        additional_data: {}
      };
      if (this.isUseRecaptcha && !codeRecaptcha) {
        this.$store.commit("recaptcha/onOpen", {
          onSubmit: this.submitForm.bind(this)
        })
        return
      }
      if (this.isUseRecaptcha && codeRecaptcha) {
        body['g-recaptcha-response'] = codeRecaptcha;
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: true });
      const utmLabels = parseUtmLabels();
      if (utmLabels) {
        body.additional_data = {
          ...body.additional_data,
          ...utmLabels
        }
      }
      body.additional_data = await getAdditionalData({...body.additional_data}, {
        $yandexMetrika: this.$yandexMetrika
      });
      const response = await this.$api.agent.transport.post("/form/send", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {
          error: errorParseNetwork(err.response)
        }
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });

        this.$toast.error(response.error);

        return
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
      this.$toast.success("Заявка успешно отправлена");
      this.resetForm();
      this.$yandexMetrika.reachGoal("forma_formcall");
      this.$yaglaaction('forma_formcall');
    },
    resetForm: function () {
      this.form = {
        name: "",
        phone: "",
        email: ""
      };
      this.$v.$reset();
    }
  }
})
